var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"starContent"},[_c('img',{staticClass:"star",style:(_vm.style),attrs:{"src":_vm.starList[0]}}),_vm._v(" "),_c('img',{staticClass:"star",style:(_vm.style),attrs:{"src":_vm.starList[1]}}),_vm._v(" "),_c('img',{staticClass:"star",style:(_vm.style),attrs:{"src":_vm.starList[2]}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaf309f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./yotta-vue-components/vision/trainStar.vue
// module id = null
// module chunks = 